export default __webpack_public_path__ + "static/media/bg-oem.1f07fc9c.jpg";